import { IListItem } from "@/components/List/models";
import { ForexCourse } from "@/feature/Forex/api/forex.interface";

export enum ForexCurrency {
	USD = '840',
	EUR = '978',
	RUB = '643',
	GBP = '826',
	JPY = '392',
	KZT = '398',
	CNY = '156',
}

export interface ForexState {
	templatesCount: number
	draftsCount: number
	courseBuy: ForexCourse[]
	courseSell: ForexCourse[]
}

export interface ForexMenuItem extends IListItem {
	title?: string
	key?: string
}